import { useQuery } from '@tanstack/react-query'

import { listBankAccounts } from '@/requests/bankAccounts'

export const bankAccountKeys = {
  all: ['bank-accounts'] as const,
  list: (userId: string) => [...bankAccountKeys.all, 'list', userId] as const,
}

export const useBankAccounts = (userId: string | undefined) =>
  useQuery({
    queryKey: bankAccountKeys.list(userId ?? ''),
    queryFn: () => listBankAccounts(userId as string),
    enabled: !!userId,
    staleTime: 30 * 1000,
  })
